export const BASE_URL = 'https://coherent-anna-maria-ifedolapo.koyeb.app/api'
// export const BASE_URL = 'https://dapps-backend.onrender.com/api'
// export const BASE_URL = 'http://localhost:5000/api'